import { withStyles } from '@material-ui/core/styles';
import { Chip } from '@material-ui/core';

const StyledActiveChip = withStyles(() => ({
  label: {
    color: 'white',
  },
  root: {
    backgroundColor: '#5AA600',
    height: 25,
    '& :active': {
      backgroundColor: '#5AA600',
    },
  },
}))(Chip);

export default StyledActiveChip;
